import React from 'react';
import { useHistory } from 'react-router-dom';

const Planerror = () => {
  const history = useHistory();

  return (
    <div className="container section-padding text-center" style={{ minHeight: '50vh' }}>
      <img
        src={'/Image/error.png'}
        alt="Payment failed"
        style={{ maxWidth: '480px', width: '100%', marginBottom: '24px' }}
      />
      <h1 className="gradient-text" style={{ fontSize: '32px', marginBottom: '12px' }}>
        Payment could not be completed
      </h1>
      <p style={{ fontSize: '16px', marginBottom: '24px' }}>
        Something went wrong while processing your payment. No charges were
        applied for this attempt. You can try again or return to the homepage.
      </p>
      <div className="d-flex justify-content-center gap-3 flex-wrap">
        <button
          className="btn btn-dark"
          type="button"
          onClick={() => history.push('/plan')}
        >
          Try again
        </button>
        <button
          className="btn btn-outline-dark"
          type="button"
          onClick={() => history.push('/')}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default Planerror;
